// @flow
import { type Event, getEventCategoryHelp } from './config';

const openFaq = (): Event => ({
  category: getEventCategoryHelp(),
  action: 'FAQ',
  label: 'Open',
});

const emailFaq = (): Event => ({
  category: getEventCategoryHelp(),
  action: 'FAQ',
  label: 'Email',
});

export default {
  openFaq,
  emailFaq,
};
